import { useQuery } from 'react-query';
import { getMerchantStores } from '../../services/stores';

/**
 * Hook to fetch merchant stores
 * @param {Object} options
 * @param {Object} options.filters - Query filters to pass to the API (e.g., { appointmentsEnabled: true })
 * @param {Object} options.useQueryOptions - Additional react-query options
 */
export function useMerchantStores({ filters = {}, useQueryOptions = {} } = {}) {
  return useQuery(
    ['merchant-stores', filters],
    async () => getMerchantStores({ loadingStatusOff: true, query: filters }),
    {
      refetchOnWindowFocus: false,
      ...useQueryOptions,
    },
  );
}
